// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket,
     IconMessages, IconLayoutKanban, 
     IconMail, IconCalendar, IconNfc,
      IconUserCircle ,
      IconBrandBadoo
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const candidatures = {
    id: 'gestion_candidature1',
    title: ["M. ", <FormattedMessage id="gestion_candidature" />],
    type: 'group',
    icon: <IconBrandBadoo />, // Use a valid icon component here

  /*   children: [
        {
            id: 'gestion_candidature_text1',
            title: <FormattedMessage id="gestion_candidature_text" />,
            type: 'collapse',
            icon: icons.IconUserCheck, */
            children: [
                        {
                            id: 'candidature_liste1',
                            title: ["1. ",<FormattedMessage id="candidature_liste" />],
                            type: 'item',
                            url: '/inscriptions/ListeCanditados'
                        },
                        {
                            id: 'candidature_liste_confirmee1',
                            title: ["2. ", <FormattedMessage id="modifier_inscriptionPOnline" />],
                            type: 'item',
                            url: '/inscriptions/ListeCanditadesRegistrer'
                        },
                        {
                            id: 'candidature_listagem_exame_com_notas1',
                            title: ["3. ", <FormattedMessage id="candidature_listagem_exame_com_notas" />],
                            type: 'item',
                            url: '/inscriptions/ListagemResposataCanditadosDepoisExame'
                            // '/user/social-profile/posts'
                        },

                        {
                            id: 'candidature_enregistrer_points1',
                            title: ["4. ",<FormattedMessage id="candidature_enregistrer_points" />],
                            type: 'item',
                            url: '#'
                            // '/user/social-profile/posts'
                        },
        
                        {
                            id: 'Pautageralpourcentageentre',
                            title: ["5. ",<FormattedMessage id="pautageral_pourcentage_entre_titre" />],
                            type: 'item',
                            url: '#'
                        },
                        {
                            id: 'candidature_statistiques_cadidatures1',
                            title: ["6. ", <FormattedMessage id="candidature_statistiques_cadidatures" />],
                            type: 'item',
                            url: '#'
                        },

                        {
                            id: 'candidature_statistiques',
                            title: ["7. ",<FormattedMessage id="candidature_statistiques" />],
                            type: 'item',
                            url: '#'
                        },

                        {
                            id: 'cours_cadidaturas1',
                            title: ["8. ", <FormattedMessage id="cours_inscription_candidature" />],
                            type: 'item',
                            url: '/inscriptions/CoursExameInscription'
                        },

                        {
                            id: 'examens_1',
                            title: ["9. ",<FormattedMessage id="candidatures_examens_automatique" />],
                            type: 'item',
                            url: '/inscriptions/ExamePerguntaCadstro'
                        } ,

                         {
                            id: 'examenStart1SalleControlExame1',
                            title: ["10. ", <FormattedMessage id="examenStart1SalleControlExame1" />],
                            type: 'item',
                            url: '/inscriptions/CandidatosExameStartSalleExameContro'
                        }  


            ]
     //   }
   // ]
};

export default candidatures;
